<div class="ticket-card"
     [class.selected]="isSelected()"
     [class]="urgencyClass()"
     (click)="onCardClick()"
     data-testid="ticket-card">

  <div class="ticket-header">
    <div class="error-type-badge" [matTooltip]="errorTypeLabel()">
      <mat-icon>{{ errorTypeIcon() }}</mat-icon>
    </div>
    <span class="time-ago">{{ timeAgo() }}</span>
  </div>

  <div class="ticket-body">
    <div class="player-name" data-testid="ticket-player-name">{{ ticket().PlayerName }}</div>
    <div class="player-email" data-testid="ticket-player-email">{{ ticket().PlayerEmail }}</div>
    <div class="error-type-label">{{ errorTypeLabel() }}</div>
  </div>

  <div class="ticket-footer">
    @if (ticket().Escalated && !ticket().Resolved) {
      <span class="status-badge escalated">
        <mat-icon>priority_high</mat-icon>
        Escalated
      </span>
    }
    @if (ticket().Resolved) {
      <span class="status-badge resolved">
        <mat-icon>check_circle</mat-icon>
        Resolved
      </span>
    }
  </div>

  @if (showQuickActions() && !ticket().Resolved) {
    <div class="quick-actions">
      <button mat-icon-button
              class="quick-action-btn"
              matTooltip="Assign to me"
              (click)="onAssignToMeClick($event)"
              data-testid="ticket-assign-to-me">
        <mat-icon>person_add</mat-icon>
      </button>
    </div>
  }
</div>
